/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_CancelledInputs */

const en_auth_error_cancelled = /** @type {(inputs: Auth_Error_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sign-in was cancelled before it finished.`)
};

const es_auth_error_cancelled = /** @type {(inputs: Auth_Error_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El inicio de sesión se canceló antes de completarse.`)
};

/**
* | output |
* | --- |
* | "The sign-in was cancelled before it finished." |
*
* @param {Auth_Error_CancelledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_cancelled = /** @type {((inputs?: Auth_Error_CancelledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_CancelledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_cancelled(inputs)
	return en_auth_error_cancelled(inputs)
});